
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asasqt-portal",
      function () {
        return require("private-next-pages/asasqt-portal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asasqt-portal"])
      });
    }
  